<template>
	<div class="layout-footer">
		<img src="/assets/layout/images/logo.png" alt="ProAstra" width="18" height="18" class="p-mr-2" />
		<span class="footer-text" style="margin-right: 5px">ProAstra</span>
        <div class="policy_footer">
            <router-link to="/cookie-policy">Cookie Policy</router-link>
            <span>|</span>
            <router-link to="/privacy-policy">Privacy Policy</router-link>
        </div>
	</div>
</template>

<script>
	export default {
		name: "AppFooter"
	}
</script>

<style scoped>

</style>